import { StatusAvaliadoEnum } from 'graphql/types.generated'

import { AvaliacaoDesenvolvimentoModel } from '../model'

export const allStatusPresent = (avaliacoes: AvaliacaoDesenvolvimentoModel[]) =>
  avaliacoes?.every((item) => item.statusButton === StatusAvaliadoEnum.PRESENTE) && avaliacoes.length
